import {
  type UploadResult,
  getDownloadURL,
  getStorage,
  ref,
  uploadBytes
} from 'firebase/storage';

import type {ImageFile, ImageMedia, ProjectType} from '../types/project';

import environment from '../constants/environment';

/**
 * Uploads files to firebase storage
 */
export default function uploadFiles(
  projectType: ProjectType,
  projectId: string,
  files: Array<ImageFile>,
  captions: Record<string, string>
): Promise<ImageMedia[]> {
  return Promise.all(
    files.map(
      file =>
        new Promise<ImageMedia>((resolve, reject) => {
          const metadata = {
            type: file.type,
            name: `${Date.now()}-${file.name}`,
            width: file.width,
            height: file.height,
            ...(captions[file.name]?.length > 0 && {
              caption: captions[file.name]
            })
          };

          const storageRef = ref(
            getStorage(),
            `${projectType}-${environment}/${projectId}/${metadata.name}`
          );

          const handleUploadSuccess = async ({ref}: UploadResult) => {
            const url = await getDownloadURL(ref);
            const media = {url, ...metadata} as ImageMedia;
            resolve(media);
          };

          uploadBytes(storageRef, file.blob).then(handleUploadSuccess, reject);
        })
    )
  );
}
